// Utility to build SEO-friendly product URLs like /product/one-piece-poster-p2
// while remaining backward-compatible with plain /product/p2 links.

export function slugify(text) {
  if (!text) return "";
  return String(text)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function productPath(product) {
  if (!product) return "/";
  const slug = slugify(product.title || product.character_name || product.sku || "");
  if (!slug) return `/product/${product.id}`;
  return `/product/${slug}-${product.id}`;
}

// Extract the product id from the slug parameter.
// Accepts both new-style slugs like "one-piece-poster-p2" and legacy plain ids like "p2".
export function extractProductId(slugOrId) {
  if (!slugOrId) return "";
  // Product ids in Mongo are always in the form "p" + hex chars.
  const m = String(slugOrId).match(/(p[a-f0-9]{1,})$/i);
  return m ? m[1] : String(slugOrId);
}
